import Api from './PhiApi'
import Constants from './Constants'
import Content from './PhiContent'
import Log from './PhiLog'
import Metadata from './PhiMetadata'
import Organization from './PhiOrganization'
import Event from './PhiEvent'
import User from './PhiUser'
import Workflow from './PhiWorkflow'
import Communication from './PhiCommunication'

class Phi {

    constructor() {

        this.initialize = (options) => {
            this.apiUrl = (options && options.apiUrl) ? options.apiUrl : Constants.apiHost
            this.apiPort = (options && options.apiPort) ? options.apiPort : Constants.apiPort
            this.Storage = (options && options.storage) ? options.storage : window.sessionStorage
            this.User = new User(this)
            this.Metadata = new Metadata(this)
            this.Content = new Content(this)
            this.Log = new Log(this)
            this.Organization = new Organization(this)
            this.Communication = new Communication(this)
            this.Event = new Event(this)
            this.Workflow = new Workflow(this)
            this.apiProtocol = (options && options.apiProtocol) ? options.apiProtocol : 'http://'
            Api.initialize(this.apiProtocol + this.apiUrl + this.apiPort, Api)
        }

        this.getSession = () => {
            let sessionToken = this.Storage.getItem('sessionToken')
            if (sessionToken) {
                sessionToken = JSON.parse(sessionToken)
                Api.setToken(sessionToken)
            }
            return sessionToken
        }

        this.setSession = (token) => {
            this.Storage.setItem('sessionToken', JSON.stringify(token))
        }

        this.removeSession = () => {
            this.Storage.removeItem('sessionToken')
        }

        this.isArray = (obj) => {
            if( Object.prototype.toString.call(obj) === '[object Array]' ) {
            return true
            }
            return false
        }

    }


}

export default new Phi()
